// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608142304/js/" + chunkId + "." + {"44":"5db5fc1d","225":"bf56d491","481":"818631aa","486":"15c1f16c","770":"f0e0f0fe"}[chunkId] + ".0.7160767317419189.chunk.js";
};